import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";


// ENDPOINT LOCAL
 //export const API_ENDPOINT = "http://localhost:8000";

// ENDPOINT PUBLICO
export const API_ENDPOINT = "https://incubator-cv.incubator-cv.com";

createApp(App).use(router).mount("#app");
